import React from 'react';

import "./linkbutton.css"

export const LinkButton = ({label, onClick}) => {

  return (
       
    <div>
      <button
       className='linkButton'
       
        onClick={onClick}
        >
         {label}
      </button>
    </div>
     
  );
};

